import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function applyDownloadScheduleTemplate (params = null, payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getCompanytemplate)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/plantillas/aplicarplantillashorariodescargaclientes',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { applyDownloadScheduleTemplate }
